export async function processBatches<T, R>(
    items: T[],
    batchSize: number,
    processor: (item: T, index: number) => Promise<R>,
    onProgress?: (completed: number, total: number) => void
): Promise<R[]> {
    const results: R[] = new Array(items.length);

    for (let i = 0; i < items.length; i += batchSize) {
        const batchEnd = Math.min(i + batchSize, items.length);
        const batchPromises = [];

        for (let j = i; j < batchEnd; j++) {
            batchPromises.push(processor(items[j], j));
        }

        const batchResults = await Promise.all(batchPromises);

        // Store results in correct order
        for (let k = 0; k < batchResults.length; k++) {
            results[i + k] = batchResults[k];
        }

        onProgress?.(Math.min(i + batchSize, items.length), items.length);
    }

    return results;
}
